import AuthService from './AuthService'

export const authService = new AuthService()
